export default "__VITE_ASSET__E2zqRYtv__"